import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Container } from "react-bootstrap";

function GuptaOvercomingChallengeswithVikashFoundationSupport() {
  return (
    <>
      <Header />
      <main id="page-content" className="main-page">
        {/* Breadcrumbs */}
        <section
          className="position-relative text-white text-center"
          style={{ height: "400px" }}
        >
          <img
            src=""
            alt="A New Hope for Disabled Children"
            className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
          />
          <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

          <Container className="position-relative d-flex flex-column justify-content-center align-items-center h-100">
            <h1 className="fw-bold display-5 mb-3">
              Gupta Overcoming Challenges with Vikash Foundation Support
            </h1>
          </Container>
        </section>
        <br></br>
        {/* Post Thumbnail */}
        <section className="post-thumbnail text-center">
          <img
            src="/images/story2_3.jpg"
            alt="Surfing man adventure"
            width={900}
            height={600}
            srcSet="
             /images/story2_3.jpg
            "
            sizes="(max-width: 900px) 100vw, 900px"
          />
        </section>

        <br></br>

        <section className="container my-5">
{/* Post Content */}
        {/* Post Content */}
        <article className="post-content">
          <p>
            Gupta Bek is a child who showed little interest in activities and
            required assistance with everyday tasks. His academic performance
            was affected, and he struggled in school. Gupta also had weak
            muscles in both of his legs, especially on the left side, which made
            it difficult for him to maintain balance while moving around.
          </p>

          <h3>Recognizing the Challenges</h3>
          <p>
            When Vikash Foundation identified Gupta’s difficulties, we
            immediately began supporting him with therapies tailored to his
            needs. His condition was addressed with a focus on both his physical
            and academic challenges.
          </p>

          <h3>Therapies and Support Provided</h3>
          <p>
            Gupta is currently receiving{" "}
            <strong>
              physiotherapy, occupational therapy, special education, and
              behavioral training
            </strong>
            . These interventions aim to strengthen his muscles, improve
            coordination, build confidence, and support his learning and social
            development.
          </p>

          <h3>Inspiring Progress</h3>
          <p>
            Thanks to consistent therapy and care, Gupta can now confidently
            manage his daily tasks on his own. He has also made remarkable
            progress physically, gaining the ability to{" "}
            <strong>walk independently</strong>.
          </p>

          <p>
            Gupta’s journey is a shining example of how timely support and
            personalized therapies can transform a child’s life. At Vikash
            Foundation, we remain dedicated to empowering children like Gupta to
            reach their full potential.
          </p>
        </article>


        </section>

        
      </main>
      <br></br>

      <Footer />
    </>
  );
}

export default GuptaOvercomingChallengeswithVikashFoundationSupport;
